import type { MultiBrandConfig } from './types';

// Website 05 — WanderLite Explorer storefront. Friendly, beginner-first,
// budget/adventure positioning for backpackers, students and first-time eSIM
// buyers. Pastel sky-blue, soft white cards, illustrated traveler, guidance-
// first ("help me choose") conversion (wander-day / wander-night palettes).
// Name/domain are PROVISIONAL.
//
// DOMAIN NOTE: points at esimsupra.com for now because every storefront shares
// ONE backend (functions/ + billing worker + D1). Before WanderLite is deployed
// as its own indexed property it MUST get its own canonical domain + contact
// email to avoid cross-brand duplicate-content / canonical conflicts (risk R14).
// Until then it is build-selectable for preview only (BRAND_ID=wanderlite-explorer).
export const wanderlite: MultiBrandConfig = {
  id: 'wanderlite-explorer',
  status: 'provisional',
  siteType: 'storefront',
  positioning:
    'Friendly, beginner-first budget/adventure eSIM storefront for backpackers, students and first-time buyers — a helpful travel companion that guides unsure visitors ("help me choose") in plain language, not a telecom marketplace.',
  theme: {
    mode: 'light', // pastel sky-blue, light-first
    defaultDark: 'wander-night',
    defaultLight: 'wander-day',
  },
  checkoutEnabled: true,
  // Beginner-friendly guided brand: hand-held plan selection. Presentation only.
  pricingDisplayMode: 'guided-beginner',
  legacy: {
    brand: {
      name: 'WanderLite',
      displayName: 'WanderLite',
      tagline: 'Affordable eSIM data for every adventure',
      description:
        'Beginner-friendly travel eSIMs for backpackers and first-time buyers. Pick a destination and we help you choose the right plan — no jargon, no physical SIM, keep your number, with simple setup help if you need it.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'WanderLite Logo',
    },
    contact: {
      // TODO(brand-email): planned dedicated inbox `hello@explorlite.com` (TBD) before indexed launch (R14). Shared inbox for now.
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} WanderLite. All rights reserved.`,
    },
    features: {
      count180Countries: '180+ Countries',
      uptimePerformance: 'Reliable 4G/5G',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for explorlite.com',
      locale: 'en-US',
    },
    stripe: {
      statementDescriptorSuffix: 'WANDER',
      accountId: 'TBD — create Stripe Connect account or use statement_descriptor_suffix on shared account',
    },
    canonical: {
      domain: 'explorlite.com',
      url: 'https://explorlite.com',
      organizationLegalName: 'TBD — register legal entity for WanderLite',
    },
    llms: {
      tagline: 'The friendly way to stay online while you travel',
      audience: 'First-time and leisure travelers who want plain-language, guided help choosing an eSIM.',
    },
  },
};

export default wanderlite;
